import { c as _c } from "react/compiler-runtime";
import { FormGeolocationInput } from "@/components/Inputs/FormInputs/form-geolocation-input/FormGeolocationInput";
import { FormMultiLocationInput } from "@/components/Inputs/FormInputs/form-multi-location-input/FormMultiLocationInput";
import { FormControl, FormField, FormItem, FormMessage } from "@/components/ui/form";
import { FormLabel } from "@/components/atoms/Form/FormLabel";
import { Gender } from "../../../api/schema";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Mars, Venus } from "lucide-react";
import { FormIncrementor } from "@/components/atoms/Form/Incrementor/FormIncrementor";
import { Separator } from "@/components/ui/separator";
import { FormToggleGroup } from "@/components/Inputs/FormInputs/form-toggle-group/FormToggleGroup";
import { PawPrint, FileText, Cigarette } from "lucide-react";
import { HOUSE_INPUT_FEATURE_OPTIONS, INTERNET_FEATURE_KEYS, INTERNET_FEATURE_OPTIONS } from "@/constants/features";
import { useHouseDetails } from "./useHouseDetails";
import { useTranslations } from "next-intl";
export function HouseDetails() {
  const $ = _c(54);
  const {
    control,
    t,
    isDemand
  } = useHouseDetails();
  const tFeatures = useTranslations("modules.listings.addRoomListing.features");
  let t0;
  if ($[0] !== isDemand || $[1] !== t) {
    t0 = isDemand ? t("demandPetFriendly") : t("petFriendly");
    $[0] = isDemand;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = {
      key: "petFriendly",
      label: t0,
      Icon: PawPrint
    };
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isDemand || $[6] !== t) {
    t2 = isDemand ? t("demandContract") : t("contract");
    $[5] = isDemand;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = {
      key: "contract",
      label: t2,
      Icon: FileText
    };
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isDemand || $[11] !== t) {
    t4 = isDemand ? t("demandSmokingAllowed") : t("smokingAllowed");
    $[10] = isDemand;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = {
      key: "smokingAllowed",
      label: t4,
      Icon: Cigarette
    };
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t3 || $[17] !== t5) {
    t6 = [t1, t3, t5];
    $[15] = t1;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  const flagOptions = t6;
  let t7;
  if ($[19] !== isDemand) {
    t7 = isDemand ? <FormMultiLocationInput name="locationCodes" required={true} maxLocations={5} /> : <FormGeolocationInput />;
    $[19] = isDemand;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Separator className="w-full" data-sentry-element="Separator" data-sentry-source-file="HouseDetails.tsx" />;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== isDemand || $[23] !== t) {
    t9 = t10 => {
      const {
        field
      } = t10;
      return <FormItem><FormLabel>{isDemand ? t("demandGender") : t("allowedGender")}</FormLabel><FormControl><RadioGroup value={field.value} onValueChange={field.onChange}><div className="flex items-center space-x-2"><RadioGroupItem value={Gender.ANY} id={Gender.ANY} /><label className="cursor-pointer mt-0.5" htmlFor={Gender.ANY}>{isDemand ? t("demandAny") : t("any")}</label></div><div className="flex items-center space-x-2"><RadioGroupItem value={Gender.MALE} id={Gender.MALE} /><label htmlFor={Gender.MALE} className="cursor-pointer flex items-center gap-1 mt-0.5">{t("male")}<Mars className="size-4 text-foreground mb-1" /></label></div><div className="flex items-center space-x-2"><RadioGroupItem value={Gender.FEMALE} id={Gender.FEMALE} /><label htmlFor={Gender.FEMALE} className="cursor-pointer flex items-center gap-1 mt-0.5">{t("female")}<Venus className="size-4 text-foreground " /></label></div></RadioGroup></FormControl><FormMessage /></FormItem>;
    };
    $[22] = isDemand;
    $[23] = t;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== control || $[26] !== t9) {
    t10 = <FormField control={control} name="gender" render={t9} data-sentry-element="FormField" data-sentry-source-file="HouseDetails.tsx" />;
    $[25] = control;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Separator className="w-full" data-sentry-element="Separator" data-sentry-source-file="HouseDetails.tsx" />;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== isDemand || $[30] !== t) {
    t12 = isDemand ? t("demandPreferences") : t("preferences");
    $[29] = isDemand;
    $[30] = t;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== flagOptions) {
    t13 = flagOptions.map(_temp);
    $[32] = flagOptions;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== t12 || $[35] !== t13) {
    t14 = <FormToggleGroup booleanFields={true} label={t12} options={t13} data-sentry-element="FormToggleGroup" data-sentry-source-file="HouseDetails.tsx" />;
    $[34] = t12;
    $[35] = t13;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== isDemand || $[38] !== t || $[39] !== tFeatures) {
    t15 = !isDemand && <><Separator className="w-full" /><FormToggleGroup name="houseFeatures" label={t("houseFeaturesTitle")} options={HOUSE_INPUT_FEATURE_OPTIONS.map(t16 => {
        const {
          key: key_0,
          icon
        } = t16;
        return {
          value: key_0,
          label: tFeatures(key_0),
          icon
        };
      })} splitGroup={{
        groupKeys: INTERNET_FEATURE_KEYS,
        segments: INTERNET_FEATURE_OPTIONS.map(t17 => {
          const {
            key: key_1,
            icon: icon_0
          } = t17;
          return {
            value: key_1,
            label: tFeatures(key_1),
            icon: icon_0
          };
        })
      }} /></>;
    $[37] = isDemand;
    $[38] = t;
    $[39] = tFeatures;
    $[40] = t15;
  } else {
    t15 = $[40];
  }
  let t16;
  if ($[41] !== isDemand) {
    t16 = !isDemand && <Separator className="w-full" />;
    $[41] = isDemand;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== control || $[44] !== isDemand || $[45] !== t) {
    t17 = !isDemand && <div className="flex flex-col sm:flex-row gap-6"><FormField control={control} name="bedrooms" render={t18 => {
        const {
          field: field_0
        } = t18;
        return <FormItem className="flex-1"><FormLabel>{t("bedrooms")}</FormLabel><FormControl><FormIncrementor containerClassName="max-w-none" labelOnZero={t("undefined")} value={field_0.value} onChange={field_0.onChange} /></FormControl><FormMessage /></FormItem>;
      }} /><FormField control={control} name="bathrooms" render={t19 => {
        const {
          field: field_1
        } = t19;
        return <FormItem className="flex-1"><FormLabel>{t("bathrooms")}</FormLabel><FormControl><FormIncrementor containerClassName="max-w-none" labelOnZero={t("undefined")} value={field_1.value} onChange={field_1.onChange} /></FormControl><FormMessage /></FormItem>;
      }} /></div>;
    $[43] = control;
    $[44] = isDemand;
    $[45] = t;
    $[46] = t17;
  } else {
    t17 = $[46];
  }
  let t18;
  if ($[47] !== t10 || $[48] !== t14 || $[49] !== t15 || $[50] !== t16 || $[51] !== t17 || $[52] !== t7) {
    t18 = <div className="flex flex-col gap-8 min-w-0" data-sentry-component="HouseDetails" data-sentry-source-file="HouseDetails.tsx">{t7}{t8}{t10}{t11}{t14}{t15}{t16}{t17}</div>;
    $[47] = t10;
    $[48] = t14;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
    $[52] = t7;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  return t18;
}
function _temp(t0) {
  const {
    key,
    label,
    Icon
  } = t0;
  return {
    value: key,
    label,
    icon: Icon
  };
}